"use client";
import React, { createContext, useContext, useRef } from "react";
import { Blog } from "@/types/blog";

interface PrefetchContextProps {
  prefetchedBlogs: React.MutableRefObject<{ [key: string]: Blog }>;
  addPrefetchedBlog: (id: string, data: Blog) => void;
}

const MAX_CACHE_SIZE = 10;

const PrefetchContext = createContext<PrefetchContextProps | undefined>(
  undefined,
);

export const PrefetchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const prefetchedBlogs = useRef<{ [key: string]: Blog }>({});

  const addPrefetchedBlog = (id: string, data: Blog) => {
    if (Object.keys(prefetchedBlogs.current).length >= MAX_CACHE_SIZE) {
      const firstKey = Object.keys(prefetchedBlogs.current)[0];
      delete prefetchedBlogs.current[firstKey];
    }
    prefetchedBlogs.current[id] = data;
  };

  return (
    <PrefetchContext.Provider value={{ prefetchedBlogs, addPrefetchedBlog }}>
      {children}
    </PrefetchContext.Provider>
  );
};

export const usePrefetch = (): PrefetchContextProps => {
  const context = useContext(PrefetchContext);
  if (!context) {
    throw new Error("usePrefetch must be used within a PrefetchProvider");
  }
  return context;
};
